import { useState } from 'react';
import type { Person } from '@shared/types.ts';
import { getStore, useAppState } from '../../data/store.ts';
import { Icon } from '../../components/Icon.tsx';
import { back } from '../../lib/router.tsx';

/** Display names and the names airlines print, which is how bookings know who's going. */
export function PeopleScreen() {
  const people = useAppState((s) => s.people);
  return (
    <div className="screen" style={{ gap: 14 }}>
      <button type="button" className="back-link" onClick={() => back('/settings')}>
        <Icon name="chevron-left" size={18} /> Settings
      </button>
      <div className="stack" style={{ gap: 4 }}>
        <h1 className="h1 h1-sm">People</h1>
        <span className="muted" style={{ fontSize: 14 }}>
          Bookings are matched to you by the names airlines and hotels print. Middle names, titles and "LAST/FIRST" order don't matter.
        </span>
      </div>
      {people.map((p) => (
        <PersonCard key={p.id} person={p} />
      ))}
    </div>
  );
}

function PersonCard({ person }: { person: Person }) {
  const store = getStore();
  const [name, setName] = useState(person.name);
  const [bookingNames, setBookingNames] = useState(person.bookingNames.join('\n'));
  const changed = name.trim() !== person.name || bookingNames.split('\n').map((n) => n.trim()).filter(Boolean).join('\n') !== person.bookingNames.join('\n');
  const id = `person-${person.id}`;
  return (
    <section className="card stack-lg" aria-label={person.name}>
      <div className="row" style={{ gap: 10 }}>
        <span className={`avatar ${person.id}`}>{person.initial}</span>
        <span className="stack" style={{ gap: 0 }}>
          <span style={{ fontWeight: 600 }}>{person.name}</span>
          {person.email && <span className="small muted">{person.email}</span>}
        </span>
      </div>
      <div className="field">
        <label htmlFor={`${id}-name`}>Display name</label>
        <input id={`${id}-name`} className="input" value={name} onChange={(e) => setName(e.target.value)} />
      </div>
      <div className="field">
        <label htmlFor={`${id}-booking`}>Names on bookings</label>
        <textarea id={`${id}-booking`} className="textarea" value={bookingNames} onChange={(e) => setBookingNames(e.target.value)} placeholder="First Middle Last" />
        <span className="help">One per line, as on a passport. Add another if you book under a second name.</span>
      </div>
      <button
        type="button"
        className="btn btn-primary"
        disabled={!changed || !name.trim()}
        onClick={() => {
          store.updatePerson(person.id, { name, bookingNames: bookingNames.split('\n') });
          store.toast(`Saved ${name.trim()}`);
        }}
      >
        Save
      </button>
    </section>
  );
}
